import React from 'react';
import { FiSearch, FiMenu, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SkinTonePicker from './SkinTonePicker';
import LanguageToggle from './LanguageToggle';
import { translations } from '../translations';

const Header = ({ searchQuery, setSearchQuery, onMenuClick, skinTone, setSkinTone, showRecent, setShowRecent, lang, setLang }) => {
  const t = translations[lang];
  return (
    <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-slate-200 px-4 py-3 md:px-6 md:py-4">
      <div className="max-w-6xl mx-auto flex flex-col gap-3">
        <div className="flex items-center gap-3 md:gap-4">
          <button 
            onClick={onMenuClick} 
            className="md:hidden p-2.5 hover:bg-slate-100 rounded-xl transition-colors bg-slate-50 border border-slate-100"
          >
            <SafeIcon icon={FiMenu} className="text-xl text-slate-600" />
          </button>
          
          <div className="relative flex-1 group">
            <SafeIcon icon={FiSearch} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-lg group-focus-within:text-indigo-500 transition-colors" />
            <input 
              type="text" 
              placeholder={t.searchPlaceholder} 
              value={searchQuery} 
              onChange={(e) => setSearchQuery(e.target.value)} 
              className="w-full pl-11 pr-4 py-2.5 md:py-3.5 bg-slate-100/50 hover:bg-slate-100 focus:bg-white border-2 border-transparent focus:border-indigo-500 rounded-2xl outline-none transition-all text-slate-700 placeholder:text-slate-400 text-sm md:text-base shadow-inner" 
            />
          </div>

          <div className="hidden sm:block">
            <LanguageToggle lang={lang} setLang={setLang} />
          </div>

          <button 
            onClick={() => setShowRecent(!showRecent)} 
            className={`flex items-center gap-2 px-3.5 py-2 rounded-xl border transition-all ${showRecent ? 'bg-indigo-600 border-indigo-600 text-white shadow-lg shadow-indigo-100' : 'bg-white border-slate-200 text-slate-600 hover:border-indigo-200 hover:text-indigo-600'}`} 
          >
            <SafeIcon icon={FiClock} className={`text-sm ${showRecent ? 'animate-pulse' : ''}`} />
            <span className="text-[10px] font-black uppercase tracking-wider hidden lg:inline"> 
              {t.recentTitle} 
            </span>
          </button>
        </div>
        
        <div className="flex items-center justify-between gap-4">
          <div className="md:hidden">
            <LanguageToggle lang={lang} setLang={setLang} />
          </div>
          <div className="flex-1 md:flex-none flex items-center justify-end gap-3">
            <span className="hidden md:inline text-[10px] font-black text-slate-400 uppercase tracking-widest"> 
              {t.skinToneTitle} 
            </span>
            <SkinTonePicker currentTone={skinTone} onToneChange={setSkinTone} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;